<template>
  <div class="aiCompany CompanyHome">
    <Header></Header>
    <div class="CompanyHomeBg">
      <img alt="" src="@a/aicompany/images/bg1.jpg" />
    </div>
    <div class="CompanyDuplicateCheck hover">
      <div class="CompanyDuplicateCheck_list CompanyDuplicateCheck_top">
        <div class="CompanyDuplicateCheck_list_li">序号</div>
        <div class="CompanyDuplicateCheck_list_li">名称</div>
        <div class="CompanyDuplicateCheck_list_li enterprise">相似名称企业</div>
        <div class="CompanyDuplicateCheck_list_li">通过率</div>
        <div class="CompanyDuplicateCheck_list_li">更多 AI 数字资产</div>
        <div class="CompanyDuplicateCheck_list_li"></div>
      </div>
      <div class="CompanyDuplicateCheck_list" v-for="(item, index) in companies" :key="item.id">
        <div class="CompanyDuplicateCheck_list_li">{{ index + 1 }}</div>
        <div class="CompanyDuplicateCheck_list_li">{{ item.name }}</div>
        <div class="CompanyDuplicateCheck_list_li enterprise">
          <span @click="showSimilarCompanies(item.info)">{{ item.enterprise }}</span>
        </div>
        <div class="CompanyDuplicateCheck_list_li progress">
          <span :style="{ width: item.progress + '%' }">{{ item.progressRate }}</span>
        </div>
        <div class="CompanyDuplicateCheck_list_li tag" @click="goToCompanyGenerate">
          <div class="list_li_l" v-for="asset in item.assets" :key="asset.id">
            <img :src="asset.imageSrc" />{{ asset.name }}
          </div>
        </div>
        <div class="CompanyDuplicateCheck_list_li more" @click="goToCompanyGenerate">
          <img alt="" src="@a/aicompany/images/sv4.svg" />
        </div>
      </div>
    </div>

    <div class="Preview" v-show="showPreview">
      <div class="Preview_content">
        <div class="Preview_content_title">
          <div class="content_title_left"><span></span>相似名称企业</div>
          <div class="content_title_right" @click="showPreview = false"><i class="el-icon-close"></i></div>
        </div>
        <div class="Preview_content_txt">
          <div class="content_txt_list">
            <div class="txt_list_li">序号</div>
            <div class="txt_list_li">公司名称</div>
            <div class="txt_list_li">法人</div>
            <div class="txt_list_li">注册时间</div>
            <div class="txt_list_li">更多</div>
          </div>
          <div class="content_txt_list" v-for="(item, index) in similarCompanies" :key="item.id">
            <div class="txt_list_li">{{ index + 1 }}</div>
            <div class="txt_list_li">
              <p>{{ item.name }}</p>
              <p>{{ item.credit_no || item.reg_no }}</p>
            </div>
            <div class="txt_list_li">{{ item.oper_name }}</div>
            <div class="txt_list_li">{{ item.start_date }}</div>
            <div class="txt_list_li click" @click="handleClick(item.id)">
              <img alt="" src="@a/img/sv9.svg" />查看
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="CompanyPBtn hover">
      <!-- <div class="CompanyPBtn_list ">免费工商注册</div> -->
      <div class="CompanyPBtn_list active" @click="exportToExcel">导出报告</div>
      <div class="CompanyPBtn_list active" @click="goToCompanyGenerate">一键注册（工商财税+数字产品开通）</div>
    </div>
    
  </div>
</template>

<script>
import Header from '@c/aiCompanyheader/aiCompanyheader';
import * as XLSX from 'xlsx';


export default {
  name: 'CompanyDuplicateCheck',
  data() {
    return {
      showPreview: false,
      companies: [],
      similarCompanies: [], // 相似企业列表
    };
  },
  created() {

  },
  mounted() {
    this.loadCompanies();
  },
  components: {
    Header
  },
  computed: {

  },
  methods: {

    goToCompanyGenerate() {
      this.$router.push('/aicompany/CompanyDigitalAssets/CompanyDigitalAssets');
    },

    async loadCompanies() {
      const selectedCompanies = JSON.parse(localStorage.getItem('selectedCompanies')) || [];

      for (const companyName of selectedCompanies) {
        try {
          const response = await this.fetchCompanyData(companyName);
          if (response.code === 1) {
            const result = response.result;

            this.companies.push({
              id: this.companies.length + 1,
              name: result.name,
              enterprise: result.enterprise,
              progress: result.progress,
              progressRate: result.progressRate,
              assets: [
                { id: 1, name: 'LOGO', imageSrc: require('@a/aicompany/images/sv10.svg') },
                { id: 2, name: 'WEB', imageSrc: require('@a/aicompany/images/sv11.svg') },
                { id: 3, name: 'E-Mail', imageSrc: require('@a/aicompany/images/sv12.svg') },
                { id: 4, name: 'PPT', imageSrc: require('@a/aicompany/images/sv13.svg') },
                { id: 5, name: '软文营销', imageSrc: require('@a/aicompany/images/sv14.svg') }
              ],
              info: result.info || [], // 添加相似企业信息
              showPreview: false,
            });
          } else {
            console.error(`获取数据失败：${response.msg}`);
          }
        } catch (error) {
          console.error('请求出错:', error);
        }
      }
    },

    // 模拟接口请求
    async fetchCompanyData(companyName) {
      try {
        // 使用 this.axios.post 发送请求
        const response = await this.axios.post('/api/CompanyName/advSearch', {
          companyName,
          uniqueId: localStorage.getItem('unique_id') || '',
        });

        // 返回响应数据
        return response; // Axios 的响应数据通常在 data 属性中
      } catch (error) {
        console.error('请求失败:', error);
        // 根据需要处理错误
        return null;
      }
    },

    showSimilarCompanies(info) {
      this.similarCompanies = info; // 更新相似企业信息
      this.showPreview = true; // 显示预览框
    },

    exportToExcel() {
      // 第一步：构建表头（左侧加一列，第一行、第二行、第三行）
      const headers = ['公司名称', ...this.companies.map(company => company.name)]; // 第一行：公司名称
      const progressRates = ['通过率', ...this.companies.map(company => company.progressRate || 'N/A')]; // 第二行：通过率
      const enterpriseCounts = ['相似企业数量', ...this.companies.map(company => company.info.length)]; // 第三行：相似企业数量

      // 计算每个企业的相似企业信息
      const infoRows = [];
      const maxInfoLength = Math.max(...this.companies.map(company => company.info.length)); // 获取最长的相似企业数量

      for (let i = 0; i < maxInfoLength; i++) {
        const row = ['相似企业信息'];  // 每行的第一列是“相似企业信息”
        this.companies.forEach(company => {
          if (company.info[i]) {
            const info = company.info[i];
            // 拼接企业信息，包含法人和注册号（如果有）
            row.push(`${info.name} (${info.start_date}), 法人: ${info.oper_name}, 注册号: ${info.credit_no || info.reg_no}`);
          } else {
            row.push('');  // 如果该行没有相似企业数据，填充空值
          }
        });
        infoRows.push(row);
      }

      // 第二步：将表格数据整合
      const data = [
        headers,           // 第一行：公司名称
        progressRates,     // 第二行：通过率
        enterpriseCounts,  // 第三行：相似企业数量
        ...infoRows        // 从第四行开始：相似企业的 info 信息
      ];

      // 第三步：生成 Excel 文件
      const ws = XLSX.utils.aoa_to_sheet(data);  // aoa_to_sheet 接受二维数组，生成 Excel 工作表
      const wb = XLSX.utils.book_new();  // 创建工作簿
      XLSX.utils.book_append_sheet(wb, ws, "公司信息");  // 添加工作表到工作簿

      // 导出 Excel 文件
      XLSX.writeFile(wb, "公司信息.xlsx");
    },

    handleClick(company_id) {
      // 跳转到目标链接
      window.open(`https://www.qixin.com/company/${company_id}`, "_blank");
    },

  },
}


</script>

<style>
@import "CompanyDuplicateCheck.css";
</style>
